import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "task-index",
  style: {
    "width": "calc( 100%-32px )",
    "padding": "0 16px 16px 16px",
    "position": "relative"
  }
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "block"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_lcSearch = _resolveComponent("lcSearch");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_LcButtons = _resolveComponent("LcButtons");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_LcSingleSelect = _resolveComponent("LcSingleSelect");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white wrap_box lcpg lcrw"
  }, {
    default: _withCtx(() => [_createVNode(_component_lcSearch, {
      class: "lcS",
      ref: "theSearch",
      onSearchhandle: _ctx.searchhandle,
      onResethandel: _ctx.resethandel,
      type: "task"
    }, null, 8, ["onSearchhandle", "onResethandel"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_LcButtons, {
      ref: "lcButtons",
      type: 2,
      onBtsEmit: _cache[1] || (_cache[1] = $event => _ctx.btsEmit($event)),
      deppgetPageInfo: _ctx.getPageInfo,
      task: "task",
      ids: _ctx.data.theids
    }, {
      db: _withCtx(() => [_createVNode(_component_el_checkbox, {
        modelValue: _ctx.data.checked,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.data.checked = $event),
        label: "我的待办",
        onChange: _ctx.mychange
      }, null, 8, ["modelValue", "onChange"])]),
      _: 1
    }, 8, ["deppgetPageInfo", "ids"]), _createVNode(_component_vxe_table, {
      id: "tasktable",
      onCheckboxChange: _ctx.selectionChange,
      onCheckboxAll: _ctx.selectionChange,
      "max-height": "550",
      "custom-config": {
        storage: true
      },
      border: "",
      "show-overflow": "",
      data: _ctx.data.tasklsittable,
      "keep-source": "",
      "column-config": {
        resizable: true
      },
      style: {
        "margin-top": "15px"
      },
      "edit-config": {
        trigger: 'click',
        mode: 'cell',
        showUpdateStatus: true,
        showInsertStatus: true
      },
      class: "ggdycss"
    }, {
      default: _withCtx(() => [_createVNode(_component_vxe_column, {
        type: "checkbox",
        width: "50",
        align: "center"
      }), _createVNode(_component_vxe_column, {
        field: "sn",
        title: "任务编号",
        width: "100",
        align: "center"
      }), _createVNode(_component_vxe_column, {
        title: "所属项目名称",
        width: "240",
        align: "left"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", {
          style: {
            "color": "#409eff",
            "cursor": "pointer"
          },
          onClick: $event => _ctx.getRouteInfo(row, '项目')
        }, _toDisplayString(row.project_name), 9, _hoisted_2)]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "name",
        title: "任务名称",
        width: "180",
        align: "left"
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", {
          style: {
            "color": "#409eff",
            "cursor": "pointer"
          },
          onClick: $event => _ctx.getRouteInfo(row, '任务')
        }, _toDisplayString(row.name), 9, _hoisted_3)]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "leader_user_name",
        title: "任务负责人",
        width: "120",
        align: "left"
      }), _createVNode(_component_vxe_column, {
        field: "reviewer_user_name",
        title: "任务审核人",
        width: "120",
        align: "left"
      }), _createVNode(_component_vxe_column, {
        field: "task_status_text",
        title: "业务状态",
        width: "120",
        align: "left"
      }), _createVNode(_component_vxe_column, {
        field: "examine_status_text",
        title: "审核状态",
        width: "120",
        align: "center"
      }), _createVNode(_component_vxe_column, {
        field: "plan_start_time_text",
        title: "预计开始日期",
        width: "220",
        align: "left"
      }), _createVNode(_component_vxe_column, {
        field: "end_time_text",
        title: "任务完成日期",
        align: "left"
      })]),
      _: 1
    }, 8, ["onCheckboxChange", "onCheckboxAll", "data"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_pagination, {
      background: "",
      onSizeChange: _ctx.handleSizeChange,
      onCurrentChange: _ctx.handleCurrentChange,
      "current-page": _ctx.data.page,
      "page-sizes": [50, 100, 150],
      "page-size": _ctx.data.size,
      class: "rwfy",
      layout: "total, sizes, prev, pager, next, jumper",
      total: _ctx.data.total
    }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])]), (_openBlock(), _createBlock(_component_LcSingleSelect, {
      key: _ctx.data.LcSingleIndex,
      isShowDialog: _ctx.data.isShowDialog,
      "onUpdate:isShowDialog": _cache[2] || (_cache[2] = $event => _ctx.data.isShowDialog = $event),
      type: _ctx.data.dia_type,
      "onUpdate:type": _cache[3] || (_cache[3] = $event => _ctx.data.dia_type = $event),
      label: _ctx.data.dia_label,
      "onUpdate:label": _cache[4] || (_cache[4] = $event => _ctx.data.dia_label = $event),
      title: _ctx.data.dia_title,
      "onUpdate:title": _cache[5] || (_cache[5] = $event => _ctx.data.dia_title = $event),
      list: _ctx.data.dia_list,
      "onUpdate:list": _cache[6] || (_cache[6] = $event => _ctx.data.dia_list = $event),
      onGetDragDownData: _ctx.getDragDownData
    }, null, 8, ["isShowDialog", "type", "label", "title", "list", "onGetDragDownData"]))]),
    _: 1
  });
}